module.exports = __webpack_public_path__ + "static/img/Alec-Tuitavake.fe567fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alec-Tuitavake.jpg
// module id = AbKj
// module chunks = 0